import { Container, Row, Col, Card } from 'react-bootstrap';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/Impressum.css';

function Impressum() {
  return (
    <div className="ImpressumWrapper">
      <Navigation />
      <div className="SiteBackground"></div>

      <Container className="py-5 mt-5">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <Card className="shadow-lg p-4">
              <Card.Body>
                <Card.Title className="fs-4 fw-semibold mb-4">Impressum:</Card.Title>
                <p className="mb-2 fs-5">Dr. Gerrit Alexander Helm</p>
                <p className="mb-2 fs-5">Stauffenbergstraße 43</p>
                <p className="mb-4 fs-5">07747 Jena</p>
                <p className="fs-5">
                  Mail: <span className="text-decoration-none">helm(at)aide-l(Punkt)de</span>
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default Impressum;
